import { render, staticRenderFns } from "./InviteJoin.vue?vue&type=template&id=0bf1eba4&scoped=true"
import script from "./InviteJoin.vue?vue&type=script&lang=js"
export * from "./InviteJoin.vue?vue&type=script&lang=js"
import style0 from "./InviteJoin.vue?vue&type=style&index=0&id=0bf1eba4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf1eba4",
  null
  
)

export default component.exports